<template>
    <LinkSwitcher
        :title="localeName"
        :icon="locale"
        :externalTo="props.href"
        dataInterfaceTarget="switch-locale"
        :isSelected="props.isSelected"
        @click="emit('click', props.locale)"
    />
</template>

<script lang="ts" setup>
import { computed } from 'vue'

import LinkSwitcher from '@/components_new/LinkSwitcher.vue'
import { LOCALE_TITLES } from '@/i18n/helpers'
import { AvailableLocale } from '@/i18n/types'

interface LocaleSwitcherProps {
    locale: AvailableLocale
    href: string
    isSelected: boolean
}

const props = defineProps<LocaleSwitcherProps>()

const emit = defineEmits<{
    click: [locale: AvailableLocale]
}>()

const localeName = computed(() => LOCALE_TITLES[props.locale])
</script>
